type RewardEntry = { description: string[]; minLevel: number; score: number };
export const rewardDic: Record<string, RewardEntry> = {
  "rewards/campfire": { description: ["Fully recover HP & MP (to max)"], minLevel: 0, score: 0 },
  "rewards/meat": { description: ["Fully recover HP (to max)"], minLevel: 0, score: 0 },
  "rewards/fish": { description: ["Fully recover MP (to max)"], minLevel: 0, score: 0 },
  "rewards/nautilus": {
    description: ["Swap HP and MP", "Fully recover HP & MP (to max)"],
    minLevel: 0,
    score: 0,
  },
  "rewards/red_amulet": { description: ["Increase HP's max by 1"], minLevel: 0, score: 0 },
  "rewards/blue_amulet": { description: ["Increase MP's max by 1"], minLevel: 0, score: 0 },
  "rewards/nut": { description: ["Valuable nut.", "Useless in game"], minLevel: 0, score: 20 },
  "rewards/pinecone": {
    description: ["Valuable pinecone.", "Useless in game"],
    minLevel: 0,
    score: 25,
  },
  // level 4+
  "rewards/crystal_ball": {
    description: ["If your HP reaches 0, restart the", "level instead of ending the game"],
    minLevel: 3,
    score: -75,
  },
  "rewards/scroll": { description: ["Hide upcoming columns"], minLevel: 3, score: 0 },
  "rewards/astrolabe": { description: ["show upcoming columns"], minLevel: 3, score: 0 },
  "rewards/emerald": {
    description: ["Very valuable emerald.", "Useless in game"],
    minLevel: 3,
    score: 50,
  },
  // level 6+
  "rewards/gold_pot": { description: ["Gain 25 coins"], minLevel: 5, score: 0 },
  "rewards/dream_catcher": {
    description: ["Set MP's max to ∞ (infinity)"],
    minLevel: 5,
    score: 0,
  },
  "rewards/diamond": {
    description: ["Very valuable diamond.", "Useless in game"],
    minLevel: 5,
    score: 100,
  },
};

export const allRewards = Object.keys(rewardDic);
